module.exports = __webpack_public_path__ + "static/media/008-bell.90d24296.svg";